import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=3e3668d9&"
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"
import style0 from "./Question.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../NVME/projects/hoachipshop-ctv/client-ctv/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports